function resolveRequestSchema(schema, schemas) {
    let result = schema;
    const visited = new Set();
    while (result.$ref) {
        const ref = result.$ref;
        if (visited.has(ref)) throw new Error(`Circular request schema reference: ${ref}`);
        visited.add(ref);
        const name = ref
            .replace(/^#\/components\/schemas\//, '')
            .replace(/~1/g, '/')
            .replace(/~0/g, '~');
        const referenced = schemas[name];
        if (!referenced) throw new Error(`Missing request schema reference: ${ref}`);
        const constraints = { ...result };
        delete constraints.$ref;
        result = { ...referenced, ...constraints };
        if (referenced.required || constraints.required) {
            result.required = [...new Set([...(referenced.required || []), ...(constraints.required || [])])];
        }
        if (referenced.properties || constraints.properties) {
            result.properties = { ...referenced.properties, ...constraints.properties };
        }
    }
    return result;
}

module.exports = { resolveRequestSchema };
